import { Component, OnInit, Inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { EmployeeService } from '../../service/employee.service';
import { Designation } from '../../models/Designation';
import { UserService } from '../../service/user.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { OnboardingService } from '../../service/onboarding.service';

@Component({
  selector: 'app-designation-dialog',
  templateUrl: './designation-dialog.component.html',
  styleUrls: ['./designation-dialog.component.css']
})
export class DesignationDialogComponent implements OnInit {
  title: string;
  message: any;
  designation: Designation;
  error: any;
  empCode: number;
  DesignationForm: FormGroup;
  designationsList: any[];
  designationbool: Boolean=false;
  constructor(private toastr: ToastrService, private userService: UserService, public dialogRef: MatDialogRef<DesignationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DesignationDialog, private _service: EmployeeService, private formBuilder: FormBuilder, private hrSvc: OnboardingService) {
    dialogRef.disableClose = true;
    // Update view with given values
    this.title = data.title;
      this.message = data.message;
  }

  ngOnInit() {
    this.designation = new Designation();
    this.getDesignations();
    this.empCode = this.userService.getEmpCode();
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.DesignationForm = this.formBuilder.group({
      DesignationName: ['', [Validators.required,Validators.pattern(nonWhitespaceRegExp)]],
    });
  }
  getDesignations() {
    this.hrSvc.getDesignations().subscribe(
      (data: any) => {
        this.designationsList = data;
      });
  }

  get f() { return this.DesignationForm.controls; }
  onConfirm(): void {
    if (!this.DesignationForm.invalid) {
      this.designation.ModifiedBy = this.empCode.toString();
      this.designationsList.forEach(item => {
        if (item.DesignationName.toLowerCase() == this.designation.DesignationName.toLowerCase()) {
          this.designationbool = true;
        }
      });
      if (this.designationbool == false) {
        this._service.SaveDesignation(this.designation).subscribe(data => {
          this.dialogRef.close(this.designation);
        }, error => this.error = error)
      }
      else {
        this.toastr.warning("Same designation exists");
        this.designation.DesignationName = null;
        this.designationbool = false;
      }
      
    }
    else {
      return;
    }


  }
  onDismiss(): void {
    // Close the dialog, return false
    this.dialogRef.close(false);
  }
}
export class DesignationDialog {

  constructor(public title: string, public message: any) {
  }
}
